import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import useGlobal from '@/composables/useGlobal'
import { CURRENT_LANGUAGE, prefixLanguage, DEFAULT_LANGUAGE } from '@utils/urls'
import { languagesList } from '@/const'


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageSelector',
  setup(__props, { expose: __expose }) {
  __expose();

const { $t } = useGlobal()
const getLanguageLink = (language: string) => prefixLanguage(window.location.href, { language })


// store.receive()


const __returned__ = { $t, getLanguageLink, ref, computed, get useGlobal() { return useGlobal }, get CURRENT_LANGUAGE() { return CURRENT_LANGUAGE }, get prefixLanguage() { return prefixLanguage }, get DEFAULT_LANGUAGE() { return DEFAULT_LANGUAGE }, get languagesList() { return languagesList } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})